<template>
    <v-app-bar color="#1887b4" dark fixed>
        <router-link to="/">
            <img class="mr-3" src="~@/assets/logo.png" alt="SIAI" height="42"/>
        </router-link>
        <v-toolbar-title class="d-none d-sm-block">
            <router-link to="/">{{title}}</router-link>
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-toolbar-items>
            <slot></slot>
        </v-toolbar-items>
    </v-app-bar>
</template>

<script>
    export default {
        name: "AppBarra",
        data: () => ({
            title: "Sistema de Avaliação Institucional",
            imagens: [
                require("../assets/logo-agetic-small.png"),
                require("../assets/logo-ufms.png")
            ]
        }),
    }
</script>

<style scoped>

</style>
